import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import PythonLogo from '../components/shared/logos/PythonLogo.vue'
import ExcelLogo from '../components/shared/logos/ExcelLogo.vue'

const vuetify = createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases: {
            ...aliases,
            pythonLogo: PythonLogo,
            excelLogo: ExcelLogo,
        },
        sets: {
            mdi,
        },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#E61E28',
                    secondary: '#1C1C1C',
                    accent: '#E61E28',
                    error: '#E61E28',
                    border: '#FAFAFA',
                    typography1: '#1C1C1C',
                    typography2: '#E61E28',
                    typography3: '#FFFFFF',
                },
            },
            dark: {
                colors: {
                    primary: '#1C1C1C',
                    secondary: '#FFFFFF',
                    accent: '#E61E28',
                    error: '#E61E28',
                    border: '#000000',
                    typography1: '#FAFAFA',
                    typography2: '#FAFAFA',
                },
            },
        },
    },
})

export default vuetify
